// import { Country } from "@/types/Country";
// import supported_countries from "@/assets/supported_countries.json";
// import usa_states from "@/assets/usa_states.json";
// import canada_states from "@/assets/canada_states.json";
import IUser from "@/models/protocols/IUser";
import IRegion from "@/models/protocols/IRegion";

export class BillingInfo {
  firstname: string = "";
  lastname: string = "";
  address: string = "";
  city: string = "";
  region: IRegion = {
    region: "",
    regionCode: "",
    regionId: 0,
  };
  postcode: string = "";
  countryId: string = "";
  telephone: string = "";
  name_on_card: string = "";
  card_number: string = "";
  expiration_date: string = "";
  cvc: string = "";
  address_book_id = 0;

  get cardTypeShort() {
    // visa
    let re = new RegExp("^4");
    if (this.card_number.match(re) != null) return "VI";

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (
      /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
        this.card_number
      )
    )
      return "MC";

    // AMEX
    re = new RegExp("^3[47]");
    if (this.card_number.match(re) != null) return "AE";

    // Discover
    re = new RegExp(
      "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
    );
    if (this.card_number.match(re) != null) return "DI";

    // Diners
    re = new RegExp("^36");
    if (this.card_number.match(re) != null) return "Diners";

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (this.card_number.match(re) != null) return "Diners - Carte Blanche";

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (this.card_number.match(re) != null) return "JCB";

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (this.card_number.match(re) != null) return "VI";

    return "";
  }

  get expirationMonth(): string {
    if (this.expiration_date.length < 2) {
      return "";
    }
    return this.expiration_date.substr(0, 2);
  }

  get expirationYear(): string {
    if (this.expiration_date.length < 4) {
      return "";
    }
    return (2000 + Number(this.expiration_date.substr(2, 2))).toString();
  }

  getPersistObject() {
    return {
      firstname: this.firstname,
      lastname: this.lastname,
      address: this.address,
      city: this.city,
      region: this.region.region,
      regionCode: this.region.regionCode,
      regionId: this.region.regionId,
      postcode: this.postcode,
      countryId: this.countryId,
      telephone: this.telephone,
    };
  }

  fromPersistObject(obj: any) {
    this.firstname = obj.firstname;
    this.lastname = obj.lastname;
    this.address = obj.address;
    this.city = obj.city;
    this.region = {
      region: obj.region,
      regionCode: obj.regionCode,
      regionId: obj.regionId,
    };
    this.postcode = obj.postcode;
    this.countryId = obj.countryId;
    this.telephone = obj.telephone;
    // eslint-disable-next-line no-console
    console.log(this.region);
  }

  fillBillingFromUser(user: IUser): void {
    if (!user.addresses.length) {
      return;
    }
    const address = user.addresses[0];
    // eslint-disable-next-line no-console
    console.log("FILLL", address);
    this.firstname = address.firstname;
    this.lastname = address.lastname;
    this.city = address.city;
    this.address = address.street.length ? address.street[0] : "";
    this.telephone = address.telephone;
    this.postcode = address.postcode;
    this.address_book_id = address.id;
    this.region = {
      region: address.region.region,
      regionCode: address.region.regionCode,
      regionId: address.region.regionId,
    };
    this.countryId = address.countryId;
  }
}
